import { useEffect } from 'react'
import useAxiosPrivate from '../../api/hooks/useAxiosPrivate'
import usePollingQuery from '../usePollingQuery'
import { useAuthContext } from '../../context/auth/AuthContextProvider'

const useUnreadNotificationsCounter = () => {
  const { user } = useAuthContext()
  const axiosPrivate = useAxiosPrivate()

  const { data, startRefresh, stopRefresh } = usePollingQuery({
    queryKey: ['unreadNotificationsCounter'],
    queryFn: async () => {
      const response = await axiosPrivate.get(
        '/api/notifications/unread/counter'
      )
      return response.data as number
    },
    intervalMs: 60_000,
  })

  useEffect(() => {
    if (user.companyOptions.includes('MENU_NOTIFICATION')) {
      startRefresh()
    }

    return () => stopRefresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    notificationsCounter: data ?? 0,
    startRefresh,
    stopRefresh,
  }
}

export default useUnreadNotificationsCounter
